import { useSearchParam } from 'react-use';
import { compact } from 'lodash';

import { isDemo } from '@dreryk/demo-variant-frontend';
import { Accordion } from '@dreryk/react-components';

import { mfaSettingsTranslationKeys, personnelTranslationKeys } from '../../translations';
import { PasswordExpirationSettings } from '../passwordExpirationSettings/PasswordExpirationSettings';

import { MfaSettings } from './mfaSettings/MfaSettings';
import { PasswordUpdateForm } from './passwordChange/PasswordUpdateForm';

export const LoginSettingsPanel = (): JSX.Element => {
   // TODO DREGAB-27686 Temporary solution, to be removed after '2026-05-07'
   const mfaSearchParam = useSearchParam('showMfa');

   return (
      <>
         <PasswordExpirationSettings />
         <Accordion
            testId={'loginSettingsPanel'}
            defaultOpenedSectionsIds={compact([mfaSearchParam ? 'mfaSettings' : undefined])}
            allowOpenMultipleSections
         >
            <Accordion.Section
               testId={'passwordChange'}
               id={'passwordChange'}
               label={personnelTranslationKeys.myAccount.password.changePassword}
            >
               <PasswordUpdateForm />
            </Accordion.Section>
            <Accordion.Section
               testId={'mfaSettings'}
               id={'mfaSettings'}
               label={mfaSettingsTranslationKeys.mfaSettingsWithTOTP}
               disabled={isDemo()}
            >
               <MfaSettings />
            </Accordion.Section>
         </Accordion>
      </>
   );
};
